exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.priceInfo[data-v-4533b3e6] {\n  height: 2.75rem;\n  color: #FF527F;\n  font-size: 1.25rem;\n  line-height: 1.25rem;\n}\n.priceInfo .textActive[data-v-4533b3e6] {\n  display: inline-block;\n  width: 3.6rem;\n  height: 0.8rem;\n}\n.priceInfo .textActive img[data-v-4533b3e6] {\n  margin-top: -0.7rem;\n  width: 100%;\n}\n.textIcon[data-v-4533b3e6] {\n  display: inline-block;\n  height: 0.8rem;\n}\n.textIcon img[data-v-4533b3e6] {\n  margin-top: -0.7rem;\n  width: auto;\n  height: 100%;\n}", ""]);

// exports
